import React, { useEffect, useState } from 'react';
import { getUserBalagruhas } from '../../api';
import AttendanceTracker from '../dashboard/AttendanceTracker';

const AdminAttendancePage = () => {
  const [balagruhas, setBalagruhas] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    getUserBalagruhas()
      .then((response) => {
        if (!active) return;
        const list = (response?.data || []).filter((item) => item?._id && item._id !== 'STOCK');
        setBalagruhas(list);
      })
      .catch((error) => {
        console.error('Failed to load Balagruhas for attendance:', error);
        if (active) setBalagruhas([]);
      })
      .finally(() => {
        if (active) setLoading(false);
      });

    return () => { active = false; };
  }, []);

  if (loading) return <div className="admin-attendance-loading">Loading attendance…</div>;

  return (
    <div className="admin-attendance-page">
      <AttendanceTracker balagruhas={balagruhas} canEdit />
    </div>
  );
};

export default AdminAttendancePage;
